
import api from './api';

export const classesAPI = {

  registerClass: (classData) => api.post('/classes/add-class', classData),
  addSections: (sectionsData) => api.post('/classes/add-sections', sectionsData),
  getclasseswithparams: (params = {}) => api.get(`/classes/get-classes-with-params`, { params }),
  getAllclasses: () => api.get(`/classes/get-all-classes`),
  getCommonClasses: () => api.get(`/classes/common-classes`),
  getCommonSections: () => api.get(`/classes/common-sections`),
  getsectionsbyclass: (classId) => api.get(`/classes/sections-by-class/${classId}`),  
}; 